import styles from './clases.module.css'

function Clases() {
    return(
        <div id='clases' className={styles.clasesMain}>
            <div className={styles.header}>
                <h3>CLASES & TALLERES</h3>
                <p>Formación especializada en técnica vocal y repertorio</p>
            </div>
            <div className={styles.clasesContainer}>
                <div className={styles.box}>
                    <div className={styles.imagenClase}>
                        
                    </div>
                    <div className={styles.boxContent}>
                        <h4 className={styles.tituloClase}>Clases de técnica vocal y repertorio</h4>
                        <p className={styles.descripcionClase}>Formación personalizada centrada en la técnica vocal con el método de técnica vocal Vasaro-Bracco y con un sistema propio de interpretación del género.</p>
                    </div>
                </div>
                <div className={styles.box}>
                    <div className={styles.imagenClase2}>
                    </div>
                    <div className={styles.boxContent}>
                        <h4 className={styles.tituloClase}>Seminarios intensivos</h4>
                        <p className={styles.descripcionClase}>Talleres especializados sobre interpretación de tango cantado, destinados a cantantes profesionales y estudiantes avanzados.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Clases